var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_vm._m(0),_c('div',{staticClass:"info"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.hospitalInfo.name))]),_c('img',{attrs:{"src":_vm.hospitalInfo.expertUrl}}),_c('div',{staticClass:"title"},[_vm._v("识别二维码添加专属助手")])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"top"},[_c('img',{attrs:{"src":require("../../assets/img/normal.jpg")}})])
}]

export { render, staticRenderFns }